import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { VENUE_CHANGES } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const venueHistoryReducer = (state, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${VENUE_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        VENUE_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(VENUE_CHANGES)(state, action)
  }
}
export default combineReducers({
  data: venueHistoryReducer,
  tableInfo: tableReducer,
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(VENUE_CHANGES, state, action),
})
